function durationText(route) {
  let text = route.duration.text

  text = text.replace(/\shoras?/, 'h')
  text = text.replace(/\sdías?/, 'd')
  text = text.replace(/\sminutos?/, 'min')

  return text
}

export default durationText
